import React from 'react'
import { InternalLink } from '@/atoms/InternalLink'
import { CaptionSM, EyebrowSM } from '@/atoms/Text'
import { paths } from '@/constants'
import { CollectibleProductResponse, NFTPackPaymentIntent } from '@/services/NftService/types'
import { Translate, useTranslate } from '@/utils/translate/translate-client'
import PurchaseMethods from '../PurchaseMethods'

interface PurchaseSectionProps {
  listingId?: number
  offerId?: number
  dropId?: number
  purchaseOfferId?: string
  loading: boolean
  isTradePurchase: boolean
  isPackPurchase: boolean
  isPurchaseOfferPurchase: boolean
  checkoutState: 'ADDRESS' | 'PAYMENT' | 'COMPLETED'
  projectId: string
  data?: NFTPackPaymentIntent
  combinedPaymentIntentData: CollectibleProductResponse
  changeAddressCheckoutState: () => void
}

const PurchaseSection: React.FC<PurchaseSectionProps> = ({
  listingId,
  offerId,
  dropId,
  purchaseOfferId,
  loading,
  isTradePurchase,
  isPackPurchase,
  isPurchaseOfferPurchase,
  checkoutState,
  combinedPaymentIntentData,
  changeAddressCheckoutState,
  projectId,
}) => {
  const { t } = useTranslate('account')

  if (loading) return null

  return (
    <div className="flex flex-col w-full mt-5">
      <EyebrowSM color="core-gray-700" className="mb-2">
        {t('paymentInformation', 'Payment Information')}
      </EyebrowSM>
      <PurchaseMethods
        isPackPurchase={isPackPurchase}
        isTradePurchase={isTradePurchase}
        isPurchaseOfferPurchase={isPurchaseOfferPurchase}
        listingId={listingId}
        offerId={offerId}
        dropId={dropId}
        purchaseOfferId={purchaseOfferId}
        loading={loading}
        isPaymentState={checkoutState === 'PAYMENT'}
        paymentIntentData={combinedPaymentIntentData}
        changeAddressCheckoutState={changeAddressCheckoutState}
        projectId={projectId}
      />
      <CaptionSM className="my-3">
        <Translate i18nKey="termsOfServiceAgreement" t={t}>
          By purchasing a Collectible Scene, you agree to the{' '}
          <InternalLink href={paths.legal.marketplaceTermsOfService} className="underline">
            Angel Marketplace Terms of Service
          </InternalLink>
        </Translate>
      </CaptionSM>
    </div>
  )
}

export default PurchaseSection
